import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import UnderlinedHeader from "../../molecules/UnderlinedHeader/UnderlinedHeader";
import layoutContext from "../../../context/LayoutContext";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const Faq = () => {
  const layout = useContext(layoutContext);

  useEffect(() => {
    layout.setSmallNavText("Frequently Asked Questions");
  }, []);

  return (
    <StyledFaq>
      <Container>
        <UnderlinedHeader bolder text={"FREQUENTLY ASKED QUESTIONS"} />
        <UnderlinedHeader
          soft
          text={"Can I return items from set individually?"}
        />
        <p>
          If any parts were purchased as a set, it is not possible to return its
          individual components. In such cases, it is possible to return the
          entire set only containing all components. Returns of a single set's
          components' will be rejected and sent back at the customer's cost.
        </p>
        <UnderlinedHeader
          soft
          text={"How to check when a product will be available again?"}
        />
        <p>
          If the product is showing as "out of stock", you can send us a message
          by clicking the green "send an inquiry" button on the product page
          itself or contact us through our contact form{" "}
          <Link to={"/contact"} className="gtm_btn_contactus">
            here
          </Link>
          .
        </p>
        <UnderlinedHeader
          soft
          text={"How to check if this part will fit my car?"}
        />
        <p>
          Please click on the "Vehicle fitment" under the product photo on the
          product page itself. A list of vehicles will appear.
        </p>
        <UnderlinedHeader soft text={"My car is not in the search bar, why?"} />
        <p>
          Your car might be rare in the European market. You can verify whether
          the product will fit your car by contacting us{" "}
          <Link to={"/contact"} className="gtm_btn_contactus">
            here
          </Link>
          .
        </p>
        <UnderlinedHeader
          soft
          text={"What are the shipping conditions for the products in stock?"}
        />
        <p>
          You can find our shipping conditions with the estimated time of
          delivery{" "}
          <Link to={"/shipping"} className="gtm_btn_shippingoptions">
            here
          </Link>
          .
        </p>
        <UnderlinedHeader
          soft
          text={"What is the warranty on Pedders products?"}
        />
        <p>
          You can find the detailed warranty conditions in our warranty form{" "}
          <Link to={"/warranties"}>here</Link>.
        </p>
        <UnderlinedHeader
          soft
          text={
            "Where can I make a warranty request about the Pedders products?"
          }
        />
        <p>
          You can make a warranty request by following the instructions on the
          Warranties page{" "}
          <a
            href={"https://dba4x4.home.pl/warranty/PEDDERS/"}
            target={"_blank"}
            rel={"noopener noreferrer nofollow"}
          >
            here
          </a>
          .
        </p>
      </Container>
    </StyledFaq>
  );
};

export default Faq;

const StyledFaq = styled.section`
  padding-top: 30px;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  color: #666666;
  text-align: justify;
  line-height: 1.66;
`;
